<h2 mat-dialog-title class="dialog-header">{{'locker.company.details.title'|traduccion}} {{data?.company?.id}}
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content mat-typography">

    <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1" [colWidths]="[100]">
            <mat-card>
                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.name.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="name" />
                    <mat-hint>{{'locker.company.details.form.name.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('name')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.domain.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="domain" />
                    <mat-hint>{{'locker.company.details.form.domain.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('domain')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.reserveDomain.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="reserveDomain" />
                    <mat-hint>{{'locker.company.details.form.reserveDomain.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('reserveDomain')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.primaryEmail.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="primaryEmail" />
                    <mat-hint>{{'locker.company.details.form.primaryEmail.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('primaryEmail')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.secondaryEmail.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="secondaryEmail" />
                    <mat-hint>{{'locker.company.details.form.secondaryEmail.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('secondaryEmail')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.phoneNumberFrom.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="phoneNumberFrom" />
                    <mat-hint>{{'locker.company.details.form.phoneNumberFrom.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('phoneNumberFrom')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.brandingColor.label'|traduccion}}</mat-label>
                    <input matInput type="color" formControlName="brandingColor" />
                    <mat-hint>{{'locker.company.details.form.brandingColor.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('brandingColor')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.company.details.form.image.label'|traduccion}}</mat-label>

                    <img [src]="imagePreview" alt="Vista previa" style="max-width: 200px; border-radius: 8px;">
                    <img
                    [src]="data?.company?.images?.imageMedium"
                    [srcset]="
                        data?.company?.images?.imageSmall + ' 200w,
                        ' + data?.company?.images?.imageMedium + ' 400w,
                        ' + data?.company?.images?.imageLarge + ' 800w'
                    "
                    />
                    <input matInput formControlName="imageName">
                    <!-- Input de archivo con referencia y evento -->
                    <input type="file" 
                            (change)="onFileSelected($event)" 
                            accept="image/*" >

                    <mat-hint>{{'locker.company.details.form.image.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('image')" ></app-form-error>
                </mat-form-field>

            </mat-card>
       
        </div>

    </form>

</mat-dialog-content>


<mat-dialog-actions align="end" class="dialog-footer">
    <span class="spacer"></span>
    <button mat-flat-button color="primary" [disabled]="!form.valid"
        (click)="confirm()">{{'locker.company.details.action.save'|traduccion}}</button>
    <button *ngIf="!isNew" mat-stroked-button color="warn"
        (click)="delete()">{{'locker.company.details.action.delete'|traduccion}}</button>
</mat-dialog-actions>
